import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=805f65dc"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=805f65dc&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('805f65dc')) {
      api.createRecord('805f65dc', component.options)
    } else {
      api.reload('805f65dc', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=805f65dc", function () {
      api.rerender('805f65dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/vocational-evaluation/tabs/five/instrument/otherAcademicTests/Main.vue"
export default component.exports